
export default {
  name: 'Callout',
  props: {
    theme: {
      type: String,
      default() {
        return 'dark'
      },
    },
    title: {
      type: String,
      required: false,
    },
    description: {
      type: String,
      required: false,
    },
    cta: {
      type: Array,
      required: false,
    },
  },
}
